import React, { useState, useEffect } from "react";
import "./FareRules.css";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import Loader from "../../Components/Loader/Loader";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://api.aeroprime.in/crm-service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#334555",
    color: theme.palette.common.white,
    fontWeight: 500,
  },
}));

const FareRules = () => {
  const [rules, setRules] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRules();
  }, []);

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: localStorage.getItem("AuthToken"),
  });

  const fetchRules = () => {
    setShowLoader(true);
    axios
      .get(`${BASE_URL}/fareRule/list`, { headers: getHeaders() })
      .then((res) => {
        setRules(res.data || []);
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        if (err.response?.status === 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      });
  };

  const handleDelete = (ruleId) => {
    if (!window.confirm(`Delete rule "${ruleId}"?`)) return;
    axios
      .delete(`${BASE_URL}/fareRule/delete/${ruleId}`, { headers: getHeaders() })
      .then(() => fetchRules())
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          window.location.href = "/";
        } else {
          alert("Failed to delete rule.");
        }
      });
  };

  const parseJson = (jsonStr) => {
    try {
      return jsonStr ? JSON.stringify(JSON.parse(jsonStr), null, 0) : "-";
    } catch {
      return jsonStr || "-";
    }
  };

  return (
    <div className="fare-rules-wrapper">
      {showLoader && <Loader hideLoader={false} />}
      <div className="fare-rules-heading">FARE RULES</div>
      <div className="Break-line-rp"></div>
      <div className="fare-rules-actions">
        <button className="add-rule-btn" onClick={() => navigate("/addFareRule")}>
          + Add New Rule
        </button>
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 900 }} aria-label="fare rules table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Rule ID</StyledTableCell>
              <StyledTableCell>Priority</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Effective From</StyledTableCell>
              <StyledTableCell>Effective To</StyledTableCell>
              <StyledTableCell>Inclusion Criteria</StyledTableCell>
              <StyledTableCell>Exclusion Criteria</StyledTableCell>
              <StyledTableCell>Baggage</StyledTableCell>
              <StyledTableCell>Updated By</StyledTableCell>
              <StyledTableCell>Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rules.length > 0 ? (
              rules.map((rule) => (
                <TableRow key={rule.ruleId} hover>
                  <TableCell>{rule.ruleId}</TableCell>
                  <TableCell>{rule.priority}</TableCell>
                  <TableCell>
                    <span className={`fare-rule-badge ${rule.enabled ? "badge-active" : "badge-inactive"}`}>
                      {rule.enabled ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                  <TableCell>{rule.effectiveFrom || "-"}</TableCell>
                  <TableCell>{rule.effectiveTo || "-"}</TableCell>
                  <TableCell className="json-cell" title={rule.inclusionCriteria}>
                    {parseJson(rule.inclusionCriteria)}
                  </TableCell>
                  <TableCell className="json-cell" title={rule.exclusionCriteria}>
                    {parseJson(rule.exclusionCriteria)}
                  </TableCell>
                  <TableCell className="json-cell" title={rule.baggage}>
                    {parseJson(rule.baggage)}
                  </TableCell>
                  <TableCell>{rule.updatedBy || "-"}</TableCell>
                  <TableCell>
                    <div className="action-icons">
                      <IconButton
                        size="small"
                        onClick={() => navigate(`/addFareRule?ruleId=${rule.ruleId}`)}
                      >
                        <EditIcon fontSize="small" style={{ color: "#334555" }} />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(rule.ruleId)}
                      >
                        <DeleteIcon fontSize="small" style={{ color: "#ef5443" }} />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center" style={{ padding: "40px" }}>
                  No fare rules configured
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default FareRules;
